import { BeePaddingOptions } from "types/bee";

export const createBeeThemeTemplate = (bannerURL?: string, rowPadding?: BeePaddingOptions) => {
  const bannerModule = [
    {
      type: "mailup-bee-newsletter-modules-image",
      descriptor: {
        image: {
          alt: "",
          src: bannerURL,
          href: "",
          target: "_blank",
          width: "1200px",
          height: "400px",
        },
        style: {
          width: "100%",
          "border-radius": "0px",
          "padding-top": "0px",
          "padding-right": "0px",
          "padding-bottom": "0px",
          "padding-left": "0px",
        },
        computedStyle: {
          class: "center autowidth",
          width: "500px",
          hideContentOnMobile: false,
        },
        mobileStyle: {},
        customAttributes: [
          {
            key: "image-type",
            value: "banner",
            target: "tag",
          },
        ],
      },
      locked: false,
    },
  ];

  // create a new bee template with banner image at the top of the page
  return JSON.stringify({
    page: {
      body: {
        container: {
          style: {
            "background-color": "#FFFFFF",
          },
        },
        content: {
          computedStyle: {
            linkColor: "#0068A5",
            messageBackgroundColor: "transparent",
            messageWidth: "500px",
          },
          style: {
            color: "#000000",
            "font-family": "Arial, Helvetica Neue, Helvetica, sans-serif",
          },
        },
        type: "mailup-bee-page-properties",
        webFonts: [],
      },
      description: "",
      rows: [
        {
          columns: [
            {
              "grid-columns": 12,
              // adding banner image into the page
              modules: bannerURL ? bannerModule : [],
              style: {
                "background-color": "transparent",
                "border-bottom": "0px dotted transparent",
                "border-left": "0px dotted transparent",
                "border-right": "0px dotted transparent",
                "border-top": "0px dotted transparent",
                "padding-bottom": "5px",
                "padding-left": "0px",
                "padding-right": "0px",
                "padding-top": "5px",
              },
            },
          ],
          container: {
            style: {
              "background-color": "transparent",
              "background-image": "none",
              "background-position": "top left",
              "background-repeat": "no-repeat",
            },
          },
          content: {
            computedStyle: {
              hideContentOnDesktop: false,
              hideContentOnMobile: false,
              rowColStackOnMobile: true,
              rowReverseColStackOnMobile: false,
              verticalAlign: "top",
            },
            style: {
              "background-color": "transparent",
              "background-image": "none",
              "background-position": "top left",
              "background-repeat": "no-repeat",
              color: "#000000",
              width: "500px",
              "padding-top": rowPadding?.paddingTop || "0px",
              "padding-right": rowPadding?.paddingRight || "0px",
              "padding-bottom": rowPadding?.paddingBottom || "0px",
              "padding-left": rowPadding?.paddingLeft || "0px",
            },
          },
          empty: false,
          locked: false,
          synced: false,
          type: "one-column-empty",
        },
      ],
      template: {
        name: "template-base",
        type: "basic",
        version: "2.0.0",
      },
      title: "",
    },
  });
};
